import React from "react";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import FloatingActionContainer from "../../../shared/FloatingActionContainer";
import InquiryButton from "./InquiryButton";
import { URLS } from "../../../../constants/urls";
import { openLinkInNewTab } from "../../../utils/openLinkInNewTab";
import { toast } from "react-toastify";

const FLOATING_MEETING_CONFIG = {
  url: URLS.GOOGLE_CALENDAR,
  label: "WEB面談を申し込む",
  tooltip: "ご希望の日時を選択してください。",
};

// 画面右下に表示される、WEB面談申し込み用のフローティングボタン
export default function FloatingMeetingButton({ isMobile, type }) {
  const { url, label, tooltip } = FLOATING_MEETING_CONFIG;

  const handleClick = () => {
    const isValidUrl = openLinkInNewTab(url);

    if (!isValidUrl) {
      toast.error("無効なリンクです");
    }
  };

  return (
    <FloatingActionContainer>
      <InquiryButton
        isMobile={isMobile}
        onClick={handleClick}
        label={label}
        tooltip={tooltip}
        type={type}
        icon={<CalendarTodayIcon sx={{ fontSize: 16 }} />}
      />
    </FloatingActionContainer>
  );
}
